export default "__VITE_ASSET__64a452e4__"